import makeStyles from '@mui/styles/makeStyles';
import { checkboxLabel, hintStrip, stepContainer } from '../ui/styles';

// Figma credentials screens (73:1854 pattern): 24px between the section
// title, inputs, checkbox, divider and API-key fields; the hint strip sits
// 8px under the UUID input.
export const createClasses = makeStyles(theme => ({
  container: {
    ...stepContainer(theme),
    gap: theme.spacing(3)
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '21px'
  },
  uuidHint: {
    ...hintStrip(theme),
    marginTop: theme.spacing(1)
  },
  confirmationLabel: checkboxLabel(theme)
}));
